<script lang="ts" setup>
definePageMeta({
  layout: false,
})

const mode = ref('magicLink')
const modeOptions = [
  { label: 'Magický odkaz', value: 'magicLink' },
  { label: 'Heslo', value: 'password' },
]

function changeMode(newMode) {
  mode.value = newMode
}

const indicatorLeftPosition = computed(() => {
  const index = modeOptions.findIndex((option) => option.value === mode.value)
  return `${index * 50}%`
})
</script>

<template>
  <main class="flex min-h-screen flex-col items-center justify-center py-10">
    <div class="mx-auto w-full max-w-sm space-y-6">
      <div class="flex text-2xl font-bold justify-start gap-2">
        <div>Přihlášení</div>
        <div>
          <span>Solve</span>
          <span class="text-orange-500">Point</span>
        </div>
      </div>
      <p class="text-sm">Vyplňte své údaje pro přihlášení</p>
      <div
        class="relative grid grid-cols-2 border-b-2 border-gray-200 dark:border-white/20"
      >
        <span
          id="mode-indicator"
          class="pointer-events-none absolute -bottom-0.5 h-0.5 w-1/2 bg-gray-500 transition-all duration-300 dark:bg-gray-200"
          :style="{ left: indicatorLeftPosition }"
        />
        <UButton
          v-for="modeOption in modeOptions"
          :key="modeOption.value"
          size="lg"
          :label="modeOption.label"
          variant="ghost"
          color="gray"
          block
          class="rounded-b-none"
          :class="{
            'text-gray-400 dark:text-gray-600': mode !== modeOption.value,
          }"
          @click="changeMode(modeOption.value)"
        />
      </div>
      <AuthLoginMagicLinkForm v-if="mode === 'magicLink'" />
      <AuthLoginPasswordForm v-if="mode === 'password'" />

      <p class="text-center text-sm">
        Ještě nemáte účet?
        <UButton
          to="/auth/register"
          variant="link"
          :padded="false"
          color="gray"
        >
          Zaregistrujte se
        </UButton>
      </p>
    </div>
  </main>
</template>
